<template>
  <v-container class="px-0" dense fluid>
    <v-card-text class="text-h5 font-weight-bold text-center"> {{ $t('ELE0323') }} ({{ $t('ELE0315') }}) </v-card-text>
    <v-card-text>
      <v-row dense class="py-0">
        <v-col>
          <v-card-text class="text-subtitle-1 font-weight-bold px-1 py-1 text-decoration-underline">
            {{ $t('ELE0127') }}:&nbsp;
            <span class="text-subtitle-1 font-weight-normal">{{ company }}</span>
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text class="text-subtitle-1 font-weight-bold px-1 py-1 text-decoration-underline">
            {{ $t('ELE0059') }}:&nbsp;
            <span class="text-subtitle-1 font-weight-normal">{{ part }}</span>
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text class="text-subtitle-1 font-weight-bold px-1 py-1 text-decoration-underline">
            {{ $t('ELE0134') }}:&nbsp;
            <span class="text-subtitle-1 font-weight-normal">{{ supplier }}</span>
          </v-card-text>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="8" class="py-0">
          <v-row dense>
            <v-col cols="6">
              <v-card-text class="text-subtitle-1 font-weight-bold px-1 py-1 text-decoration-underline">
                {{ $t('ELE0128') }}:&nbsp;
                <span class="text-subtitle-1 font-weight-normal">{{ dateFrom }}</span>
              </v-card-text>
            </v-col>
            <v-col cols="6">
              <v-card-text class="text-subtitle-1 font-weight-bold px-1 py-1 text-decoration-underline">
                {{ $t('ELE0129') }}:&nbsp;
                <span class="text-subtitle-1 font-weight-normal">{{ dateTo }}</span>
              </v-card-text>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="pt-2">
        <v-col>
          <v-card outlined>
            <v-card-title class="pt-1 pb-0">
              {{ $t('ELE0023') }}
              <v-spacer />
            </v-card-title>
            <v-data-table :headers="rateListHeader" :items="rateList" disable-pagination hide-default-footer dense>
              <template v-slot:header>
                <thead>
                  <tr>
                    <th class="top-headers border-top" colspan="2"></th>
                    <th
                      v-for="(item, index) in weekHeader"
                      v-bind:key="index"
                      :class="`${index !== weekHeader.length - 1 ? 'top-headers' : ''} border-top text-center`"
                      :colspan="item.days"
                    >
                      {{ item.name }}
                    </th>
                  </tr>
                </thead>
              </template>
              <template v-slot:item.main="{ item }">
                <td :class="`${item.class + ' v-data-table__divider'}`">{{ item.main }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="defectList.length > 0">
        <v-col>
          <v-card outlined>
            <v-card-title class="pt-1 pb-0">
              {{ $t('ELE0321') }}
              <v-spacer />
            </v-card-title>
            <v-data-table :headers="defectListHeader" :items="defectList" disable-pagination hide-default-footer dense>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-container>
</template>

<script>
export default {
  name: 'DefectRateReport',

  props: {
    company: {
      type: String,
      required: true,
    },
    part: {
      type: String,
      required: false,
    },
    supplier: {
      type: String,
      required: false,
    },
    dateFrom: {
      type: String,
      required: true,
    },
    dateTo: {
      type: String,
      required: true,
    },
    rateListHeader: {
      type: Array,
      required: true,
    },
    rateList: {
      type: Array,
      required: true,
    },
    weekHeader: {
      type: Array,
      required: true,
    },
    defectListHeader: {
      type: Array,
      required: false,
    },
    defectList: {
      type: Array,
      required: false,
    },
  },
}
</script>
